import { mapPersonType, useFindPersonDetailsSuspense } from '@api';
import { NavigateBackButton } from '@common';
import { Group } from '@mantine/core';
import { Route } from 'src/routes/_rootLayout/persons/$id';

export const PersonDetailsHeader: React.FC = () => {
  const { id } = Route.useParams();
  const { data: personDetails } = useFindPersonDetailsSuspense(id, {
    query: { select: (data) => mapPersonType(data.data) },
  });

  const personName = `${personDetails.firstname} ${personDetails.lastname}`;

  return (
    <Group gap="xs">
      <NavigateBackButton to="/persons" />
      {personName}
    </Group>
  );
};
